import styled from 'styled-components';
import { useHistory } from 'react-router';
import { IFormAudience } from '../interfaces';
import { getQueryFormId } from 'modules/EmailBrowser/utils';
import BlankProfilePhoto from '../../../../assets/img/blank_profile_photo.png';
import { ReactComponent as RedirectionIcon } from 'assets/img/icons/RedirectionIcon.svg';
import { Tooltip, Typography } from 'antd';
import { useState } from 'react';
import PersonalityBulletWidget from 'modules/Common/Components/PersonalityBulletWidget';

const { Text } = Typography;

const Wrapper = styled.div<{ clickable: undefined | number }>`
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1fr 1fr 1fr;
  align-items: center;
  /* gap: 16px; */
  /* width: 100%; */
  height: 78px;
  align-items: center;
  border-radius: 8px;
  background: ${(props) => (props.clickable ? '#fff' : '#eeeeee')};
  box-shadow: 0px 0px 16.875px -1.40625px rgba(0, 0, 0, 0.08);
  margin-bottom: 8px;
  margin-top: 12px;
  cursor: ${(props) => (props.clickable ? 'pointer' : 'not-allowed')};
  @media all and (max-width: 1439px) {
    width: 84.5vw;
  }
  @media all and (min-width: 1440px) and (max-width: 1480px) {
    width: 83vw;
  }
`;

const UserName = styled.div<{ clickable?: undefined | number; borderColor: string }>`
  display: flex;
  align-items: center;
  .username-span img {
    overflow: hidden;
    object-fit: cover;
    width: 60px;
    height: 60px;
    border-radius: 100%;
    border: ${(props) => (props.borderColor ? `2px solid ${props.borderColor}` : '')};
  }
  .user-info {
    display: flex;
    flex-flow: column;
    padding-left: 12px;
  }
  .name-ellipse {
    color: ${(props) => (!props.clickable ? '#C1C1C1' : '#000')};
    font-family: 'Roboto Slab';
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 23.994px;
    @media all and (max-width: 1439px) and (max-height: 729px) {
      font-size: 13px !important;
    }
  }
  .email-ellipse {
    color: ${(props) => (!props.clickable ? '#C1C1C1' : '#1ec252')};
    font-family: 'Roboto';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 15px;
    @media all and (max-width: 1439px) and (max-height: 729px) {
      font-size: 13px !important;
    }
  }
  .designation-ellipse {
    color: ${(props) => (!props.clickable ? '#C1C1C1' : '#424b50')};
    font-family: 'Roboto';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 15px;
    @media all and (max-width: 1439px) and (max-height: 729px) {
      font-size: 13px !important;
    }
  }
`;

const UserCompany = styled.div<{ notNumber?: string | boolean; clickable?: undefined | number }>`
  display: flex;
  align-items: center;
  .user-company {
    color: ${(props) => (props.clickable ? '#5E7079' : '#C1C1C1')};
    font-family: 'Roboto';
    font-size: ${(props) => (props.notNumber === true ? '14px' : '16px')};
    font-style: normal;
    font-weight: 500;
    line-height: 23.994px;
    letter-spacing: -0.375px;
    padding-left: 0px;
    @media all and (max-width: 1439px) and (max-height: 729px) {
      font-size: 13px !important;
    }
    @media all and (max-width: 1080px) {
      padding-left: 0px !important;
    }
  }
`;

const UserPersonality = styled.div<{ clickable: undefined | number }>`
  display: flex;
  align-items: center;
  .user-personality .personality-bullet-widget {
    .personality-bulltet-title {
      color: ${(props) => !props.clickable && '#C1C1C1'};
    }
    @media all and (min-width: 1920px) {
      padding-left: 1px !important;
    }
    @media all and (max-width: 1439px) and (max-height: 729px) {
      padding-left: 0;
      .title {
        font-size: 13px;
      }
    }
    @media all and (max-width: 1080px) {
      padding-left: 0px !important;
    }
  }
`;

const UserConversion = styled.div<{ notNumber?: string | boolean; clickable?: undefined | number }>`
  display: flex;
  align-items: center;
  .user-conversion-div {
    display: flex;
    align-items: center;
  }
  .user-conversion {
    color: ${(props) => (props.clickable ? '#8AA4E5' : '#C1C1C1')};
    font-family: 'Roboto';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 17.2px;
    letter-spacing: -0.319px;
    padding-left: 0px;
    @media all and (max-width: 1439px) and (max-height: 729px) {
      font-size: 13px !important;
    }
    @media all and (max-width: 1080px) {
      padding-left: 0px !important;
    }
  }
  .redirect-icon {
    opacity: ${(props) => (props.clickable ? 1 : 0.5)};
  }
`;
const UserSubmitted = styled.div<{ clickable: undefined | number }>`
  display: flex;
  align-items: center;
  .user-submitted-div {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .user-submitted {
    margin: 0;
    color: ${(props) => (props.clickable ? '#7e7e7e' : '#C1C1C1')};
    font-family: 'Roboto';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 14.063px;
    letter-spacing: -0.387px;
    @media all and (max-width: 1439px) and (max-height: 729px) {
      font-size: 13px !important;
      padding-left: 0 !important;
    }
    @media all and (min-width: 1024px) and (max-width: 1279px) {
      padding-left: 0 !important;
    }
    @media all and (max-width: 1080px) {
      padding-left: 0px !important;
    }
  }
`;

const UserRecord = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  @media all and (max-width: 1366px) {
    justify-content: center !important;
  }
  @media all and (max-width: 1280px) {
    justify-content: start !important;
  }
  .user-deleted {
    margin: 0;
    color: #7e7e7e;
    font-family: 'Roboto';
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 10px;
    letter-spacing: -0.145px;
    background-color: #fff;
    border-radius: 3px;
    padding: 4px 5px;
    white-space: nowrap;
    margin-right: 14px;
    @media all and (max-width: 1366px) {
      margin: 0 !important;
    }
    @media all and (max-width: 1152px) {
      margin-left: -50px !important;
    }
  }
`;

interface UserListCardProps {
  user: IFormAudience; // Pass an array of User objects
}

const UserListCard: React.FC<UserListCardProps> = (props: UserListCardProps) => {
  const [ellipsis, setEllipsis] = useState(true);
  const { user } = props;
  const history = useHistory();
  const formId = getQueryFormId();
  const handleRedirection = () =>
    history.push(`/analytics/contacts/dashboard/?contact_id=${user.contactId}&page_source=analytics-content&form_id=${formId}`);

  const handleRedirectSubmissionDomain = (event: any, origin: string) => {
    event.stopPropagation();
    if (origin !== 'N/A') {
      const cleanedOrigin = origin.replace(/(^\w+:|^)\/\//, ''); // removed unwanted http : // or https : // from url
      window.open('https://' + cleanedOrigin, '_blank')?.focus(); // https added to prevent origin being appended to current domain
    }
  };

  return (
    <Wrapper clickable={user.contactId} onClick={() => user.contactId && handleRedirection()}>
      <UserName borderColor={user.color} style={{ gridColumn: '1' }} clickable={user.contactId}>
        <span className="username-span" style={{ paddingLeft: '14px' }}>
          <img className="user-img" src={user.image ? user.image : BlankProfilePhoto} alt="#" />
        </span>
        <div className="user-info">
          <Text className="name-ellipse" style={ellipsis ? { width: '9vw' } : undefined} ellipsis={ellipsis ? { tooltip: user.fullName } : false}>
            {user.fullName}
          </Text>
          <Text className="email-ellipse" style={ellipsis ? { width: '9vw' } : undefined} ellipsis={ellipsis ? { tooltip: user.email } : false}>
            {user.email}
          </Text>
          <Text
            className="designation-ellipse"
            style={ellipsis ? { width: '9vw' } : undefined}
            ellipsis={ellipsis ? { tooltip: user.designation } : false}
          >
            {user.designation}
          </Text>
        </div>
      </UserName>
      <UserCompany clickable={user.contactId} notNumber={user.company === 'N/A'}>
        <div className="user-company-div">
          <Text className="user-company" style={ellipsis ? { width: 100 } : undefined} ellipsis={ellipsis ? { tooltip: user.company } : false}>
            {user.company}
          </Text>
        </div>
      </UserCompany>
      <UserPersonality clickable={user.contactId}>
        <div className="user-personality">
          <PersonalityBulletWidget title={user.personality} color={user.color} />
        </div>
      </UserPersonality>
      <UserConversion clickable={user.contactId} notNumber={user.company === 'N/A'}>
        <div className="user-conversion-div" onClick={(e: any) => handleRedirectSubmissionDomain(e, user.origin)}>
          <Tooltip title={user.origin}>
            <Text className="user-conversion" style={ellipsis ? { width: 'auto', maxWidth: '125px' } : undefined} ellipsis={ellipsis ? true : false}>
              {user.originDomain}
            </Text>
            <span className="redirect-icon" style={{ marginLeft: '4px' }}>
              <RedirectionIcon />
            </span>
          </Tooltip>
        </div>
      </UserConversion>
      <UserSubmitted clickable={user.contactId}>
        <div className="user-submitted-div">
          <Text className="user-submitted" style={ellipsis ? { width: 200 } : undefined} ellipsis={ellipsis ? { tooltip: user.submittedAt } : false}>
            {user.submittedAt}
          </Text>
        </div>
      </UserSubmitted>
      <UserRecord>{!user.contactId && <span className="user-deleted">Contact Deleted</span>}</UserRecord>
    </Wrapper>
  );
};

export default UserListCard;
